import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPaymentAmount,
  IPaymentResult,
  ISelectedCoupon,
  paymentStep,
  studentPaymentMode,
} from '../models/studentStudent.model';
import {
  IStudentBreakdown,
  IStudentBreakdownDetail,
  IStudentPayment,
} from '../models/payments.model';

interface IStudentStudentState {
  paymentResults: IPaymentResult[];
  paymentStep: paymentStep;
  sortedStudentPayments: IStudentPayment[];
  couponDiscounts: ISelectedCoupon[];
  paymentAmounts: IPaymentAmount[];
  paymentBreakdowns: IStudentBreakdown[];
  paymentMode: studentPaymentMode;
  paymentBreakdownDetails: IStudentBreakdownDetail[];
  classReceiptUrl?: string;
  onlineReceiptUrl?: string;
}

const initialState: IStudentStudentState = {
  paymentResults: [],
  paymentStep: 'before',
  sortedStudentPayments: [],
  couponDiscounts: [],
  paymentAmounts: [],
  paymentBreakdowns: [],
  paymentMode: 'payment',
  paymentBreakdownDetails: [],
};

const studentStudentSlicer = createSlice({
  name: 'studentStudent',
  initialState,
  reducers: {
    setPaymentResult: (
      state: IStudentStudentState,
      { payload }: PayloadAction<IPaymentResult[]>,
    ) => {
      state.paymentResults = [...payload];
    },
    setPaymentStep: (
      state: IStudentStudentState,
      { payload }: PayloadAction<paymentStep>,
    ) => {
      state.paymentStep = payload;
    },
    setSortedStudentPayments: (
      state: IStudentStudentState,
      { payload }: PayloadAction<IStudentPayment[]>,
    ) => {
      state.sortedStudentPayments = [...payload];
    },
    setCouponDiscounts: (
      state: IStudentStudentState,
      { payload }: PayloadAction<ISelectedCoupon[]>,
    ) => {
      state.couponDiscounts = [...payload];
    },
    setPaymentAmounts: (
      state: IStudentStudentState,
      { payload }: PayloadAction<IPaymentAmount[]>,
    ) => {
      state.paymentAmounts = [...payload];
    },
    setPaymentBreakdowns: (
      state: IStudentStudentState,
      { payload }: PayloadAction<IStudentBreakdown[]>,
    ) => {
      state.paymentBreakdowns = [...payload];
    },
    setPaymentMode: (
      state: IStudentStudentState,
      { payload }: PayloadAction<studentPaymentMode>,
    ) => {
      state.paymentMode = payload;
    },
    setPaymentBreakdownDetails: (
      state: IStudentStudentState,
      { payload }: PayloadAction<IStudentBreakdownDetail[]>,
    ) => {
      state.paymentBreakdownDetails = [...payload];
    },
    setClassReceiptUrl: (
      state: IStudentStudentState,
      { payload }: PayloadAction<string>,
    ) => {
      state.classReceiptUrl = payload;
    },
    setOnlineReceiptUrl: (
      state: IStudentStudentState,
      { payload }: PayloadAction<string>,
    ) => {
      state.onlineReceiptUrl = payload;
    },
  },
});

export const {
  setPaymentResult,
  setPaymentStep,
  setSortedStudentPayments,
  setCouponDiscounts,
  setPaymentAmounts,
  setPaymentBreakdowns,
  setPaymentMode,
  setPaymentBreakdownDetails,
  setClassReceiptUrl,
  setOnlineReceiptUrl,
} = studentStudentSlicer.actions;

export default studentStudentSlicer.reducer;
